/**
 * Replace the locale 'ar-u-nu-latn' (generated by ConfigureI18n) with 'ar' to
 * be able to send the 'ar' locale in Sapi. SAPI/RAA does not recognize
 * 'ar-u-nu-latn' as a valid language.
 * @param locale - The locale to be mapped
 * @returns The mapped locale
 */
export const mapLatinNumbersSystemToArabic = (locale: string) =>
  locale === 'ar-u-nu-latn' ? 'ar' : locale
